import { render, staticRenderFns } from "./PhoneCallModal.vue?vue&type=template&id=0892f230"
import script from "./PhoneCallModal.vue?vue&type=script&lang=js"
export * from "./PhoneCallModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports